__turbopack_context__.v({
  "active": "dUedxG_active",
  "block": "dUedxG_block",
  "colors": "dUedxG_colors",
  "disabled": "dUedxG_disabled",
  "disclaimer": "dUedxG_disclaimer",
  "disclaimerTextCaptionStyle": "dUedxG_disclaimerTextCaptionStyle",
  "disclaimerTextStyle": "dUedxG_disclaimerTextStyle",
  "error-message": "dUedxG_error-message",
  "form": "dUedxG_form",
  "input-rows": "dUedxG_input-rows",
  "light": "dUedxG_light",
  "root": "dUedxG_root",
  "row": "dUedxG_row",
  "select-wrapper": "dUedxG_select-wrapper",
  "sizes": "dUedxG_sizes",
  "submit": "dUedxG_submit",
  "tag": "dUedxG_tag",
  "text-description": "dUedxG_text-description",
  "titles": "dUedxG_titles",
});
